import type { OrderSummary } from './Order.ts';
import type { Stop } from './Stop.ts';
import type { TourStatus } from './Tour.ts';

const EDITABLE_STOP_STATUSES = new Set(['open', 'reached']);
const EDITABLE_LOAD_ORDER_STATUSES = new Set(['open', 'planned']);
const EDITABLE_UNLOAD_ORDER_STATUSES = new Set(['open', 'planned', 'in-transit', 'loading']);
const EDITABLE_EXECUTE_ORDER_STATUSES = new Set(['open', 'planned', 'in-transit']);

export const isStopEditable = (stop: Stop, order?: OrderSummary, tourStatus?: TourStatus): boolean => {
    if (tourStatus === 'finished' || !order?.status || !stop.status || !EDITABLE_STOP_STATUSES.has(stop.status)) {
        return false;
    }

    if (stop.type === 'load') {
        return EDITABLE_LOAD_ORDER_STATUSES.has(order.status);
    }

    if (stop.type === 'unload') {
        return EDITABLE_UNLOAD_ORDER_STATUSES.has(order.status);
    }

    if (stop.type === 'execute') {
        return EDITABLE_EXECUTE_ORDER_STATUSES.has(order.status);
    }

    return false;
};
